import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { locationFields } from './common/locationFields';
import {
  productCategoryField,
  productFields,
  productWeightField,
  productWeightUnitField,
} from './common/productFields';
import { msg } from '@lingui/core/macro';
import { genericQuantityField } from './common/sharedFields';
import { genericUnitField } from './common/sharedFields';

export const consumerGoodsTextileProductUsePhaseMetadata = {
  displayName: msg({
    message: 'Sold products: Textile use',
    context: 'Activity data schema name for textile product use phase',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...productFields,
    dry_method: {
      displayName: msg({
        message: 'Dry method',
        context: 'Name of a column in table of activity data',
      }),
      externalDescription: msg({
        message: 'How the product is dried',
        context: 'Description of a column in table of activity data',
      }),
    },
    fabric_category: {
      displayName: msg({
        message: 'Fabric category',
        context: 'Name of a column in table of activity data',
      }),
      externalDescription: msg({
        message: 'The main type of fabric for the product.',
        context: 'Description of a column in table of activity data',
      }),
    },
    product_category: productCategoryField,
    product_weight: productWeightField,
    product_weight_unit: productWeightUnitField,
    quantity: {
      ...genericQuantityField,
      externalDescription: msg({
        message: 'The quantity of product orders',
        context: 'Quantity',
      }),
    },
    unit: genericUnitField,
    wash_method: {
      displayName: msg({
        message: 'Wash method',
        context: 'Name of a column in table of activity data',
      }),
      externalDescription: msg({
        message: 'How the product is washed',
        context: 'Description of a column in table of activity data',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
